import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { finalize } from 'rxjs/operators';
import { ProjectQuery } from 'src/app/projects/state/project.query';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { ResultMapFilterService } from '../result-map/service/result-map-filter.service';
import { ResultTreeService } from './service/result-tree.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-result-tree',
  templateUrl: './result-tree.component.html',
  styleUrls: ['./result-tree.component.scss']
})
export class ResultTreeComponent implements OnInit, OnDestroy {

  isLoading: boolean;
  treeControl = new NestedTreeControl<TreeNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<TreeNode>();

  tagsEnabled: boolean;

  constructor(
    private resultTreeService: ResultTreeService,
    private projectQuery: ProjectQuery,
    private simulationQuery: SimulationQuery,
    private resultMapFilterService: ResultMapFilterService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;

    const projectId = this.projectQuery.getActiveId();
    const simulatioId = this.simulationQuery.getActiveId();

    this.resultTreeService.get(projectId, simulatioId)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(tree => {
        this.dataSource.data = [tree];
        this.treeControl.dataNodes = this.dataSource.data;
        this.expand(tree, 0);
      });

    this.resultMapFilterService.tags$.subscribe(tags => this.tagsEnabled = !!tags.length);
  }

  ngOnDestroy(): void {
    this.resultMapFilterService.clear();
  }

  hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;

  expand(node: TreeNode, maxLevel: number) {
    if (maxLevel > 3) {
      return;
    }
    this.treeControl.expand(node);
    if (node.children) {
      node.children.forEach(child => this.expand(child, ++maxLevel));
    }
  }

  update(node: TreeNode) {
    node.selected = !node.selected;

    if (!node.tags) {
      return;
    }

    if (node.selected) {
      this.resultMapFilterService.addFilter(...node.tags);
    } else {
      this.resultMapFilterService.removeFilter(...node.tags);
    }
  }
}

interface TreeNode {
  label: string;
  children?: TreeNode[];
  tags: string[];
  selected: boolean;
}
